import { combineReducers } from "@reduxjs/toolkit";
import lineGroupSlice from "./slices/lineGroupSlice";
import mixAndMatchDetailSlice from "./slices/mixAndMatchDetailSlice";
import mixAndMatchSlice from "./slices/mixAndMatchSlice";
import offerDetailSlice from "./slices/offerDetailSlice";
import offerOnDiscountDetailSlice from "./slices/offerOnDiscountDetailSlice";
import offerOnDiscountSlice from "./slices/offerOnDiscountSlice";
import offerSlice from "./slices/offerSlice";
import validationPeriodSlice from "./slices/validationPeriodSlice";
import employeeDiscountSlice from "./slices/employeeDiscountSlice";
import couponSlice from "./slices/couponSlice";
import couponDetailSlice from "./slices/couponDetailSlice";
import couponIssuerSlice from "./slices/couponIssuerSlice";
import offerOnDiscountConfigSlice from "./slices/offerOnDiscountConfigSlice";

export default combineReducers({
  validationPeriod: validationPeriodSlice,
  offer: offerSlice,
  offerDetail: offerDetailSlice,
  mixAndMatch: mixAndMatchSlice,
  mixAndMatchDetail: mixAndMatchDetailSlice,
  lineGroup: lineGroupSlice,
  offerOnDiscount: offerOnDiscountSlice,
  offerOnDiscountDetail: offerOnDiscountDetailSlice,
  employeeDiscount: employeeDiscountSlice,
  coupon: couponSlice,
  couponDetail: couponDetailSlice,
  couponIssuer: couponIssuerSlice,
  offerOnDiscountConfig: offerOnDiscountConfigSlice,
});
